import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
export interface DialogData {
  expiredSession: boolean;
  countdown: number;
}

@Component({
    selector: 'app-idle-warning-modal',
    templateUrl: './idle-warning-modal.component.html',
    styleUrls: ['./idle-warning-modal.component.scss'],
    standalone: false
})
export class IdleWarningModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {  }

}
